import styles from "./styles/GenerationLoading.module.css";
import React from "react";


function GenerationLoading() {
    return <div className={styles.wrapper}>.</div>;
}

export default GenerationLoading;